/**
     * Setting global opacity variables based on the dynamic primary 
     * color set in vuetify.options.js
     * 
     * Vuetify doesn't allow opacity on their theme colors so needed 
     * to add them here manually.
     * 
     * Param: primary - Color code (Hex)
     */
export async function createOpacityVariables(primary, secondary) {
  try {
    if (typeof document != undefined || typeof process != undefined) {
      const root = document.querySelector(':root')
      const myVariables = {
        '--v-primary-opacity-90': primary + 'E6',  //  90% opacity
        '--v-primary-opacity-80': primary + 'CC',  //  80% opacity
        '--v-primary-opacity-60': primary + '99',  //  60% opacity
        '--v-primary-opacity-48': primary + '7A',  //  48% opacity
        '--v-primary-opacity-36': primary + '5C',  //  36% opacity
        '--v-primary-opacity-24': primary + '3D',  //  24% opacity
        '--v-primary-opacity-12': primary + '1F',  //  12% opacity
        '--v-primary-opacity-06': primary + '0F',  //  06% opacity

        '--v-secondary-opacity-90': secondary + 'E6',  //  90% opacity
        '--v-secondary-opacity-80': secondary + 'CC',  //  80% opacity
        '--v-secondary-opacity-60': secondary + '99',  //  60% opacity
        '--v-secondary-opacity-48': secondary + '7A',  //  48% opacity
        '--v-secondary-opacity-36': secondary + '5C',  //  36% opacity
        '--v-secondary-opacity-24': secondary + '3D',  //  24% opacity
        '--v-secondary-opacity-12': secondary + '1F',  //  12% opacity
        '--v-secondary-opacity-06': secondary + '0F',  //  06% opacity
      };
      Object.entries(myVariables).forEach(v => root.style.setProperty(v[0], v[1]));

    }
  }
  catch(e){
    console.error(e, e.response)
  }
}